<template>
  <div>
    <div id="map"></div>
    <template v-if="!!this.google && !!this.map">
      <map-provider
        :google="google"
        :map="map"
      >
        <slot/>
      </map-provider>
    </template>
  </div>
</template>

<script>
/* global google */
import { googleApiKey } from '@/config';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import MapProvider from './MapProvider.vue';

export default {
  props: {
    mapConfig: {
      type: Object,
      default: () => ({
        zoom: 12,
        center: {
          lat: 46.8095965,
          lng: 7.1033581,
        },
      }),
    },
  },
  components: {
    MapProvider,
  },
  data() {
    return {
      google: null,
      map: null,
    };
  },
  mounted() {
    GoogleMapsApiLoader({
      apiKey: googleApiKey,
    }).then((google) => {
      this.google = google;
      this.initializeMap();
    });
  },
  methods: {
    initializeMap() {
      const mapContainer = this.$el.querySelector('#map');
      const { Map } = this.google.maps;
      this.map = new Map(mapContainer, this.mapConfig);
    },
  },
};
</script>

<style scoped>
#map {
  height: 200px;
  width: 100%;
}
</style>
